// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HPu_o","colMin":"styles_colMin__3cs1z"};